<template>
  <Layout >
    <PageHead HeadType="Service"/>
    <ProductOverview :summarizeText="SummarizeText" :videoData="videoData" />

    <!-- 业务蓝图 -->
    <section 
      class="rn-section-gap slider-bg-image" 
      :style="{ 'background-image': `url(${require('@/assets/images/ProductService/common/business-blueprint.png')})` }">
      <SectionTitle :title="$t('product.business_blueprint')" description="BUSINESS BLUEPRINT" textAlign="center" />
      <div class="container">
        <ServiceBusinessBlueprint />
      </div>
    </section>

    <ProductAbility :abilityData=AbilityData />
    <ProductSuperiority :productSuperiorityData="ProductSuperiorityData" />
    <!-- 典型案例 -->
    <ClassicCases :classicCasesData="ClassicCasesData" />
  </Layout>
</template>

<script>
    import Layout from '../../components/common/Layout'
    import Icon from '../../components/icon/Icon'
    import Separator from '../../components/elements/separator/Separator'
    import SectionTitle from '../../components/elements/sectionTitle/SectionTitle'
    import ProductOverview from './components/ProductOverview.vue'
    import ServiceBusinessBlueprint from './components/BusinessBlueprint/ServiceBusinessBlueprint.vue'
    import ProductAbility from './components/ProductAbility.vue'
    import PageHead from './components/PageHead.vue'
    import ProductSuperiority from './components/ProductSuperiority/ProductSuperiority.vue'
    import ClassicCases from '../IndustrySolution/components/ClassicCases.vue'
    import { 
        Service_icon01,
        Service_icon02,
        Service_icon03,
        Service_icon04,
        numImage01,
        numImage02,
        numImage03,
        numImage04,
        numImage05,
        zhongtongBackground,
        HITACHIBackground,
        YTOBackground,
        DeltaIcon,
        A0SMITHIcon,
        sacredsunIcon,
        HAMAMATSUIcon,
        ServiceAbility01,
        ServiceAbility02,
        ServiceAbility03,
        ServiceAbility04,
        ServiceAbility05,
      } from './Image.js'

    export default {
        name: 'VyungService',
        components: {
          Icon, Layout, Separator, SectionTitle, 
          ProductOverview, ServiceBusinessBlueprint, ProductAbility, PageHead,ProductSuperiority,ClassicCases,
        },
        data() {
            return {
                //产品概述
                videoData:[{
                    src:process.env.VUE_APP_VIDEO_URL+'/$web/video/product_service.mp4?'+process.env.VUE_APP_VIDEO_RAXWDL,
                    // src:'https://vyunghome.blob.core.chinacloudapi.cn/$web/video/loyalty.mp4?sp=racwdl&st=2023-05-23T06:12:11Z&se=2023-06-23T14:12:11Z&spr=https&sv=2022-11-02&sr=c&sig=ajt5HDJh%2BGE7TJ%2Bdo8uNSAqOUJzZWan37uhgbk%2B7bRI%3D',
                    thumb: require('@/assets/images/ProductService/VyungService/service_tumb.jpg')
                }],
                SummarizeText: this.$t('product.VyungService.product_overview.text'),
                //产品功能
                AbilityData:[
                  {
                    title: this.$t('product.VyungService.product_ability.card01.title'),
                    text:[{
                      subtext: this.$t('product.VyungService.product_ability.card01.text.subtext01'),
                    },{
                      subtext: this.$t('product.VyungService.product_ability.card01.text.subtext02'),
                    },{
                      subtext: this.$t('product.VyungService.product_ability.card01.text.subtext03'),
                    },{
                      subtext: this.$t('product.VyungService.product_ability.card01.text.subtext04'),
                    },{
                      subtext: this.$t('product.VyungService.product_ability.card01.text.subtext05'),
                    }],
                    contentImage:ServiceAbility01,
                    numImage:numImage01,
                  },
                  {
                    title: this.$t('product.VyungService.product_ability.card02.title'),
                    text:[{
                      subtext: this.$t('product.VyungService.product_ability.card02.text.subtext01'),
                    },{
                      subtext: this.$t('product.VyungService.product_ability.card02.text.subtext02'),
                    },{
                      subtext: this.$t('product.VyungService.product_ability.card02.text.subtext03'),
                    },],
                    contentImage:ServiceAbility02,
                    numImage:numImage02,
                  },
                  {
                    title: this.$t('product.VyungService.product_ability.card03.title'),
                    text:[{
                      subtext: this.$t('product.VyungService.product_ability.card03.text.subtext01'),
                    },{
                      subtext: this.$t('product.VyungService.product_ability.card03.text.subtext02'),
                    },{
                      subtext: this.$t('product.VyungService.product_ability.card03.text.subtext03'),
                    },],
                    contentImage:ServiceAbility03,
                    numImage:numImage03,
                  },
                  {
                    title: this.$t('product.VyungService.product_ability.card04.title'),
                    text:[{
                      subtext: this.$t('product.VyungService.product_ability.card04.text.subtext01'),
                    },{
                      subtext: this.$t('product.VyungService.product_ability.card04.text.subtext02'),
                    },{
                      subtext: this.$t('product.VyungService.product_ability.card04.text.subtext03'),
                    },],
                    contentImage:ServiceAbility04,
                    numImage:numImage04,
                  },
                  {
                    title: this.$t('product.VyungService.product_ability.card05.title'),
                    // text:'',
                    contentImage:ServiceAbility05,
                    numImage:numImage05,
                  },
                ],

                //产品优势
                ProductSuperiorityData:[
                  {
                    title: this.$t('product.VyungService.product_advangtages.card01.title'),
                    text: this.$t('product.VyungService.product_advangtages.card01.text'),
                    contentImage:Service_icon01,
                  },
                  {
                    title: this.$t('product.VyungService.product_advangtages.card02.title'),
                    text: this.$t('product.VyungService.product_advangtages.card02.text'),
                    contentImage:Service_icon02,
                  },
                  {
                    title: this.$t('product.VyungService.product_advangtages.card03.title'),
                    text: this.$t('product.VyungService.product_advangtages.card03.text'),
                    contentImage:Service_icon03,
                  },             
                  {
                    title: this.$t('product.VyungService.product_advangtages.card04.title'),
                    text: this.$t('product.VyungService.product_advangtages.card04.text'),
                    contentImage:Service_icon04,
                  }
                ],

                //产品案例
                ClassicCasesData:[
                  {
                    // imageBackground: HITACHIBackground,
                    brandIcon: DeltaIcon,
                  },
                  {
                    // imageBackground: zhongtongBackground,
                    brandIcon: A0SMITHIcon,
                  },
                  {
                    // imageBackground: YTOBackground,
                    brandIcon: sacredsunIcon,
                  },
                  {
                    // imageBackground: YTOBackground,
                    brandIcon: HAMAMATSUIcon,
                  },
                ]
              }
        },
        methods:{
       
        }
    }
</script>